import { useTranslations } from '@vocab/react';
import {
  Box,
  ContentBlock,
  Columns,
  Column,
  Heading,
  Stack,
} from 'braid-design-system';
import React from 'react';

import { StaticPageProvider } from '../../../components/';

import translations from './.vocab';
import { EnquiryForm } from './components';
import { ContactInfo } from './components/ContactInfo/ContactInfo';

const StaticPageProps = {
  title: 'Contact Us',
  currentPage: 'contact us',
  siteSection: 'contact',
  returnUrl: '/contactus/',
  eventName: 'contact_us_displayed',
  enableHreflang: true,
};

const ContactUs = () => {
  const { t } = useTranslations(translations);

  return (
    <StaticPageProvider {...StaticPageProps}>
      <Box background="surface" paddingY="xlarge" paddingX={['gutter', 'none']}>
        <ContentBlock>
          <Stack space="xlarge">
            <Box paddingX="gutter">
              <Heading level="1" weight="weak">
                {t('Contact Us')}
              </Heading>
            </Box>
            <Stack space="medium">
              <Columns space="xlarge" collapseBelow="tablet">
                <Column>
                  <EnquiryForm />
                </Column>
                <Column width="2/5">
                  <ContactInfo />
                </Column>
              </Columns>
            </Stack>
          </Stack>
        </ContentBlock>
      </Box>
    </StaticPageProvider>
  );
};

export default ContactUs;
